module.exports = __webpack_public_path__ + "img/icon-trash.eddacb97.svg";